<template>
  <div>
    <day-agenda-list-item-placeholder/>
    <day-agenda-list-item-placeholder/>
    <day-agenda-list-item-placeholder/>
  </div>
</template>
<script>
import DayAgendaListItemPlaceholder from './DayAgendaListItemPlaceholder';

export default {
  name: 'day-agenda-list-placeholder',
  components: {
    DayAgendaListItemPlaceholder,
  },
};
</script>

<style lang="scss" scoped>
  @import "~@homeservices/design-kit/tools";

  @import "~@/views/Dashboard/constants";

  .DAY-AGENDA-LIST-ITEM-PLACEHOLDER {
    display: flex;
    flex: 0 0 auto;
    flex-direction: column;
    min-height: $appointment-list-item-min-height;
    padding: 1*$unit 1*$unit 1*$unit 1 *$unit;
    background-color: white;
    border-bottom: 1px solid $color-gray30;
  }

  .PLACEHOLDER {
    @include rect(74px, 16px);
    margin: $unit/2 0;
  }

  .WIDE-PLACEHOLDER {
    @include rect(300px, 24px);
  }
</style>
